import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';

import { ChecklistToggleRow, ChecklistToggleState } from './checklist-toggle.model';

const initialState: ChecklistToggleState = {
  [ChecklistToggleRow.CloseDiscounts]: false,
  [ChecklistToggleRow.CloseExpenses]: false,
  [ChecklistToggleRow.ForecastCurves]: false,
  [ChecklistToggleRow.ForecastMethodology]: false,
  [ChecklistToggleRow.ForecastTimeline]: false,
  [ChecklistToggleRow.GatherContracts]: false,
  [ChecklistToggleRow.GatherEstimates]: false,
  [ChecklistToggleRow.GatherInvoices]: false,
  [ChecklistToggleRow.GatherPatients]: false,
};

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'checklist-toggle' })
export class ChecklistToggleStore extends Store<ChecklistToggleState> {
  constructor() {
    super(initialState);
  }

  toggleRow(row: ChecklistToggleRow) {
    this.update({
      [row]: !this.getValue()[row],
    });
  }
}
